<template>
  <ActionButton
    v-if="props.cargoInsuranceCertificate.data"
    mode="secondary"
    :actions-by-status="actionsByStatus"
    :status="props.cargoInsuranceCertificate.data.status"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { ActionCommand, Loadable, RygenMenuItem } from '@rygen/rygen-ui/model';

import {
  CargoInsuranceCertificate,
  CargoInsuranceStatus,
  ShipmentAction,
} from '@/model';

import ActionButton from '@rygen/rygen-ui/components/button/ActionButton.vue';

const props = defineProps<{
  cargoInsuranceCertificate: Loadable<CargoInsuranceCertificate>;
}>();

const emit = defineEmits<{
  (event: 'command', payload: ActionCommand<ShipmentAction>): void;
}>();

const { t } = useI18n();

const actionsByStatus: {
  [cargoInsuranceStatus in CargoInsuranceStatus]: RygenMenuItem[];
} = {
  ['QUOTE_RECEIVED']: [],
  ['CERTIFICATE_ISSUED']: [
    {
      label: t('cargoInsurance.actions.viewCertificate'),
      command: () => {
        window.open(
          props.cargoInsuranceCertificate.data?.certificateLink,
          '_blank',
        );
      },
    },
    {
      label: t('cargoInsurance.actions.fileClaim'),
      command: () => {
        window.open(
          props.cargoInsuranceCertificate.data?.fileClaimLink,
          '_blank',
        );
      },
      requiredAuthorization: ['shipment', 'purchaseCargoInsurance'],
      visible:
        props.cargoInsuranceCertificate?.data?.status === 'CERTIFICATE_ISSUED',
    },
    {
      key: ShipmentAction.CARGO_INSURANCE_CANCEL,
      label: t('cargoInsurance.actions.cancelPolicy'),
      command: () =>
        emit('command', { action: ShipmentAction.CARGO_INSURANCE_CANCEL }),
      requiredAuthorization: ['shipment', 'purchaseCargoInsurance'],
      visible:
        props.cargoInsuranceCertificate?.data?.status === 'CERTIFICATE_ISSUED',
    },
  ],
  ['CERTIFICATE_CANCELLED']: [],
};
</script>
